import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { authService } from "../services";
import { toast } from "react-toastify";
import countries from "../utils/wp_country.json";

const Signup = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const [selectedPhoneCode, setSelectedPhoneCode] = useState("+44");
  const [showNumberModal, setShowNumberModal] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCountryId, setSelectedCountryId] = useState(null);

  const {
    register,
    handleSubmit,
    watch,
    reset,
    trigger,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });

  // const onSubmit = async (data) => {
  //   try {
  //     const payload = { email: data.email };
  //     const res = await authService.GetEmailExistAPI(payload);
  //     if (res.success) {
  //       toast.error(res.message || "Something went wrong.");
  //       reset();
  //     } else {
  //       navigate("/interest", { state: data });
  //     }
  //   } catch (error) {
  //     navigate("/interest", { state: data });
  //   }
  // };





  // **********  Onsubmit **************
  const onSubmit = async (data) => {
    try {
   // Remove only the first 0 if it exists
    let phoneNumber = data.phone;
    if (phoneNumber.startsWith("0")) {
      phoneNumber = phoneNumber.substring(1);
    }



      const fullPhoneNumber = `${selectedPhoneCode} ${phoneNumber}`;
      const payload = {
        ...data,
        phone: fullPhoneNumber,
      };

      const res = await authService.GetEmailExistAPI({ email: data.email });
      if (res.success) {
        toast.error(res.message || "Something went wrong.");
        reset();
      } else {
        navigate("/interest", { state: payload });
      }
    } catch (error) {
        let phoneNumber = data.phone;
             if (phoneNumber.startsWith("0")) {
                phoneNumber = phoneNumber.substring(1);
              }

      const fullPhoneNumber = `${selectedPhoneCode} ${phoneNumber}`;
      const payload = { ...data, phone: fullPhoneNumber };
      navigate("/interest", { state: payload });
    }
  };

  const password = watch("password");

  const handleCountrySelect = (country) => {
    setSelectedPhoneCode(country.phonecode); // update phone code
    setSelectedCountryId(country.id);
    setShowNumberModal(false); // close modal
  };

  // Filtered country list based on search
  const filteredCountries = countries?.countries?.filter((country) =>
    country.nicename.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="landing-container mobile-css2">
      {/* Logo */}
      <div className="logo-container mobile-css">
        <img src="/images/mainLogo.png" alt="Logo" className="mian-logo" />
      </div>

      {/* Signup Form */}
      <div className="sign-up-hearder">
        <h2>Sign Up</h2>
        <p>
          Become a member and start earning points to spend on exclusive food &
          drink experiences and gift cards.
        </p>
      </div>

      <div className="member-all-signup">
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* First Name */}
          <div className="sign-up-input">
            <label className="form-label text-white fs-6">First Name*</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter it here"
              maxLength={50}
              onInput={(e) => {
                let value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                value = value.charAt(0).toUpperCase() + value.slice(1);
                e.target.value = value;
              }}
              {...register("firstName", {
                required: "First name is required",
              })}
            />
            {errors.firstName && (
              <small className="text-danger">{errors.firstName.message}</small>
            )}
          </div>

          {/* Surname */}
          <div className="sign-up-input">
            <label className="form-label text-white fs-6">Surname*</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter it here"
              maxLength={50}
              onInput={(e) => {
                let value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                value = value.charAt(0).toUpperCase() + value.slice(1);
                e.target.value = value;
              }}
              {...register("surName", {
                required: "Surname is required",
              })}
            />
            {errors.surName && (
              <small className="text-danger">{errors.surName.message}</small>
            )}
          </div>

          {/* Email */}
          <div className="sign-up-input">
            <label className="form-label text-white fs-6">Email*</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter it here"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Invalid email format",
                },
              })}
            />
            {errors.email && (
              <small className="text-danger">{errors.email.message}</small>
            )}
          </div>

          {/* Phone Number */}
          <div className="sign-up-input">
            <label className="form-label text-white fs-6 bt-i22">
              Phone Number*
              <button
                type="button"
                className="btn btn-sm btn-outline-light i-bt11"
                onClick={() => setShowModal(true)}
              >
                i
              </button>
            </label>

            <div className="number-text">
              <div className="number-text2">
                <input
                  type="text"
                  className="form-control"
                  // placeholder="+44"
                  placeholder={selectedPhoneCode}
                  onClick={() => {
                    setShowNumberModal(true);
                  }}
                  // disabled
                />
              </div>

              <input
                type="text"
                className="form-control"
                placeholder="Enter it here"
                maxLength={11}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
                {...register("phone", {
                  required: "Phone number is required",
                  // validate: (value) =>
                  //   !value.startsWith("0") || "Phone number cannot start with 0",
                })}

              />
              {/* <input
                type="text"
                className="form-control"
                placeholder="Enter it here"
                maxLength={11}
                {...register("phone", {
                  required: "Phone number is required",
                  validate: (value) =>
                    value === "" || !value.startsWith("0")
                      ? true
                      : "Phone number cannot start with 0",
                })}
                onInput={(e) => {
                  const digitsOnly = e.target.value.replace(/\D/g, "");
                  e.target.value = digitsOnly;
                  setValue("phone", digitsOnly);
                  trigger("phone");
                }}
              /> */}
            </div>
            {errors.phone && (
              <small className="text-danger">{errors.phone.message}</small>
            )}
          </div>

          {/* Promo Code */}
          <div className="sign-up-input">
            <label className="form-label text-white fs-6">Promocode</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter it here"
              maxLength={32}
              {...register("promocode", {
                maxLength: {
                  value: 32,
                  message: "Promocode cannot exceed 32 characters",
                },
              })}
            />
            {/* {errors.promocode && (
              <small className="text-danger">{errors.promocode.message}</small>
            )} */}
          </div>

          {/* Password Code */}
          <div className="sign-up-input">
            <label className="form-label text-white fs-6">Password*</label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter it here"
              // {...register("password")}
              {...register("password", {
                required: "Password is required",
                pattern: {
                  value:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,64}$/,
                  message:
                    "Password must be 8–64 characters with at least one lowercase, one uppercase, one number, and one special character",
                },
              })}
            />
            {errors.password && (
              <small className="text-danger">{errors.password.message}</small>
            )}
          </div>

          {/* Confirm Password */}
          <div className="sign-up-input">
            <label className="form-label text-white fs-6">
              Confirm Password*
            </label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter it here"
              {...register("confirmPassword", {
                required: "Please confirm your password",
                validate: (value) =>
                  value === password || "Passwords do not match",
              })}
            />
            {errors.confirmPassword && (
              <small className="text-danger">
                {errors.confirmPassword.message}
              </small>
            )}
          </div>

          {/* Next Button */}
          <button type="submit" className="sign-up-button">
            NEXT
          </button>
        </form>

        {/* Already a member? */}
        <p className="mt-3 text-center text-white already-lg1">
          Already a member?{" "}
          <span
            className="text-decoration-underline"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/login")}
          >
            Log In
          </span>
        </p>
      </div>

      {/* Modal */}
      <Modal
        className="design222 numb oneup"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <div className="all-modal-design">
          <div className="iconIII">
            <button className="modelibutton">i</button>
          </div>

          <h4>Why do we need your phone number?</h4>
          <p>
            So we can keep you updated about your reservation. It is also
            required to make a booking.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => setShowModal(false)}
          >
            UNDERSTOOD
          </button>
        </div>
      </Modal>

      {/* Model For Country code*/}
      {showNumberModal && (
        <Modal
          className="design222 numb oneup"
          show={showNumberModal}
          onHide={() => setShowNumberModal(false)}
          centered
        >
          <Modal.Body className="p-3">
            {/* Search Box */}
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            {/* Scrollable Country List */}
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {filteredCountries?.map((country) => (
                <div
                  key={country.id}
                  className="d-flex justify-content-between align-items-center py-2 border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleCountrySelect(country)}
                >
                  <div>
                    <div style={{ fontWeight: "bold" }}>{country.nicename}</div>
                    <div style={{ fontSize: "12px", color: "#888" }}>
                      {country.phonecode}
                    </div>
                  </div>
                  {selectedCountryId === country.id && (
                    <div style={{ fontSize: "20px", color: "green" }}>✔️</div>
                  )}
                </div>
              ))}
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default Signup;
